import React from 'react';
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/auth'
import { db } from '../../firebase'
import { deleteDoc ,doc } from "firebase/firestore";

firebase.initializeApp({
    apiKey: "AIzaSyDsyn2HZMzb6nOENNy0C_1PzTB9qc5frnM",
    authDomain: "thelovebirds-icecream.firebaseapp.com",
    projectId: "thelovebirds-icecream",
    storageBucket: "thelovebirds-icecream.firebasestorage.app",
    messagingSenderId: "662471881287",
    appId: "1:662471881287:web:c0984b857b04a712487762",
    measurementId: "G-M2NFRVX1PL"
})
const firestore = firebase.firestore()
const user = firebase.auth()
const booking = firestore.collection("Bookings")

function SubmitForm(data) {
    // console.log(itemCount, bookingData)
  const handleSubmit = async (event) => {
    event.preventDefault();
    // Perform actions when the form is submitted
    // You can submit data to a server, handle user input, etc.
    console.log(user.currentUser)
    if(!user.currentUser){
      window.location.href = '/login';
   }
   console.log( data)
    console.log(  {
    detail: data.bookingData.detail,
    phoneNumber: user.currentUser.phoneNumber ?? "",
    email: user.currentUser.email ?? "",
    uid: user.currentUser.uid,
    name: data.bookingData.name,
    price:data.bookingData.price,
    img:data.bookingData.img,
  })

    await booking.add(
      {
        detail: data.bookingData.detail,
        phoneNumber: user.currentUser.phoneNumber ?? "",
        email: user.currentUser.email ?? "",
        uid: user.currentUser.uid,
        name: data.bookingData.name,
        img: data.bookingData.img,
        price:data.bookingData.price * data.itemCount,
        itemCount:data.itemCount,
        bookingDone: false,
        paymentDone: false
      }
    ).then(()=>{
        console.log("booking submited successfully")
    })

  };

  return (
    <form onSubmit={handleSubmit}>
      {/* Other form fields go here */}      
      {/* Submit button */}
      <button className='btn btn-primary btn-sm' type="submit">Submit</button>
    </form>
  );
}


function RemoveBooking(id) {
  // Define a function to be executed when the button is clicked
  const handleClick = async () => {
  console.log(id.id)
    const documentRef = doc(db, 'Bookings', id.id);

    try {
      await deleteDoc(documentRef);
      console.log('Document successfully deleted');
    } catch (error) {
      console.error('Error deleting document: ', error);
    }

  };
  return (
    <div>
      <button onClick={handleClick}className='btn btn-danger btn-sm'>Remove</button>
    </div>
  );
}


export  {SubmitForm,RemoveBooking};
